import { COLOR_PALETTE, COLORS } from './colors';
import { Theme } from './types';

export const lightTheme: Theme = {
    colors: COLORS,
    semantic: {
        primary: COLOR_PALETTE.primary.p50,
        primaryLight: COLOR_PALETTE.primary.p5,
        primaryHover: COLOR_PALETTE.primary.p60,
        onPrimary: COLOR_PALETTE.primary.p0,
        primaryContainer: COLOR_PALETTE.primary.p20,
        primaryContainerHover: COLOR_PALETTE.primary.p30,
        onPrimaryContainer: COLOR_PALETTE.primary.p90,
        infoContainerLight: COLOR_PALETTE.blue.p20,
        successContainerLight: COLOR_PALETTE.green.p10,
        successLight: COLOR_PALETTE.green.p60,
        errorContainer: COLOR_PALETTE.red.p10,

        secondary: COLOR_PALETTE.secondary.p50,
        secondaryHover: COLOR_PALETTE.secondary.p60,
        onSecondary: COLOR_PALETTE.secondary.p100,

        textPrimary: '#4c4c4c',
        textDisabled: COLOR_PALETTE.neutral.p40,
        border: COLOR_PALETTE.neutral.p20,
        skeleton: COLOR_PALETTE.neutral.p20,

        body: COLOR_PALETTE.secondary.p50,
        neutral: COLOR_PALETTE.neutral.p50,
        onNeutral: COLOR_PALETTE.neutral.p0,
        background: COLOR_PALETTE.secondary.p50,
        backgroundLight: COLOR_PALETTE.neutral.p5,
        onBackground: COLOR_PALETTE.neutral.p90,
        surface: COLOR_PALETTE.neutral.p0,
        onSurface: COLOR_PALETTE.neutral.p90,

        divider: COLOR_PALETTE.neutral.p20,
        disabled: COLOR_PALETTE.neutral.p40,

        error: COLOR_PALETTE.red.p50,
        onError: COLORS.white,
        success: COLOR_PALETTE.green.p50,
        onSuccess: COLORS.white,
        warning: COLOR_PALETTE.yellow.p50,
        onWarning: COLORS.black,
        info: COLOR_PALETTE.blue.p50,
        onInfo: COLORS.white,
    },
};
